"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const table = {
    "tile": 0,
    "caip10-link": 1
};
exports.default = table;
//# sourceMappingURL=doctype-table.js.map